import Vue from 'vue';
import Swiper from '@/components/swiper/Swiper.vue';
import ProductItem from '@/modules/products/containers/ProductItem.vue';
export default Vue.extend({
    components: { Swiper, ProductItem },
    props: {
        products: {
            type: Array,
            default: [],
        },
        title: {
            type: String,
            default: '',
        },
        isFiltered: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
            default: '',
        },
        isViewMoreActive: {
            type: Boolean,
            default: true,
        },
        isLoading: Boolean,
    },
    data() {
        return {
            menuCategories: ['Alcohol', 'Electronics', 'Beauty', 'Others'],
            selectedCategory: '',
        };
    },
    methods: {
        changeCategory(category) {
            this.selectedCategory = category;
        },
        goToLink() {
            // if (this.link) {
            //   window.location.href = this.link;
            // }
            window.location.href = '/category';
        },
    },
});
